export default __webpack_public_path__ + "static/media/movie-tickets.18b6d00b.svg";